import { Component } from '@angular/core';
import { ChangeDataService } from 'src/app/Services/ChangeData/changeData.service';
import { delay } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/Api/api.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-nosotros',
  templateUrl: './nosotros.component.html',
  styleUrls: ['./nosotros.component.css'],
})
export class NosotrosComponent {
  newData: any[] = [];

  index: number = 0;
  defaultSelect = 1;
  tittle = '';
  cargando = true;

  constructor(
    private changeDataService: ChangeDataService,
    private _apiService: ApiService,
    private sanitizer: DomSanitizer
  ) {
    this.changeDataService.onChangedIndex$.pipe(delay(0)).subscribe((x) => {
      if (Number(x) === 0) {
        this.getFormatos();
      } else {
        this.getTramites(x);
      }
    });
    _apiService.get('tabla-tipo/Tramite').then((data) => {
      this.sidebarLinks = [
        {
          id: 0,
          decorator: true,
          icon: 'fas fa-file-alt fa-lg',
          tittle: 'Formatos',
        },
        ...data.tablaTipo.map((registro: any) => ({
          id: registro.id,
          decorator: false,
          icon: registro.icono + ' fa-lg',
          tittle: registro.nombre,
        })),
      ] ?? [{}];

      if (data.tablaTipo.length === 0) {
        this.defaultSelect = 0;
        this.sidebarLinks = [
          {
            id: 0,
            decorator: true,
            icon: 'fas fa-file-alt fa-lg',
            tittle: 'Formatos',
          },
        ];
        this.cargando = false;

        this.changeDataService.onChangeTittle(this.sidebarLinks[0].tittle);
        this.getFormatos();
        return;
      }

      this.changeDataService.onChangeTittle(this.sidebarLinks[1].tittle);
      this.getTramites(Number(this.sidebarLinks[1]!!.id));
    });
  }

  getFormatos() {
    this.index = Number(0);
    this._apiService.get('raw/3/formatos.html').then((data: any) => {
      this.newData = [
        {
          content: data.contenido,
        },
      ];
    });
  }

  getTramites(x: number) {
    this._apiService.get('tramite/' + x).then((data) => {
      this.cargando = false;
      this.newData = [...data.tramites];
      this.index = Number(x);
      this.newData.forEach((tramite, index: number) => ({
        content: this._apiService
          .get('raw/2/' + tramite.rutaTramite)
          .then((data: any) => {
            const newContentWithIframes = data.contenido.includes('<oembed')
            ? this.replaceOembedWithIframe(`${data.contenido}`)
            : data.contenido;
          this.newData[index].content = newContentWithIframes;
          }),
      }));
    });
  }

  private replaceOembedWithIframe(htmlString: string): SafeHtml {
    const oembedRegex = /<oembed\s+url="([^"]+)"\s*\/?>/g;
    const frameHtml = htmlString.replace(oembedRegex, (match, url) => {
      const videoId = url.split('v=')[1];
      return `<div class="ratio ratio-16x9">
      <iframe src="https://www.youtube.com/embed/${videoId}" 
       frameborder="0" allow="accelerometer; autoplay;
        clipboard-write; encrypted-media;
         gyroscope; picture-in-picture"
          allowfullscreen></iframe>
          </div>`;
    });
    const frameHtmlValidate = frameHtml.replace('</oembed>', '');
    return this.sanitizer.bypassSecurityTrustHtml(frameHtmlValidate);
  }

  sidebarLinks: any[] = [];

  dataArrays: any[] = [];
}
